




















import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AlterationI18nMixin from '@/modules/budget/alteration/mixins/alteration-i18n-mixin';
import { IReasonGroup, reasonGroupText } from './alteration-reason-api';

/**
 * Ячейка колонки "Примечание" таблиц обязательств/платежей (заявка АБП, разрез "по АБП").
 * Показывает причину отклонения на языке интерфейса (fallback на другой язык при пустом значении)
 * в сокращённом виде (первые строки) либо заглушку "Примечание не указано"; полный текст - в модалке
 * (c-reason-modal) и во всплывающей подсказке. Иконка редактирования/добавления - только при editable === true.
 * EAK-808: viewable - иконка просмотра (событие view) для примечаний без права редактирования
 * (справки (расходы) - причины нескольких заявок АБП склеены через перевод строки);
 * alwaysViewable - иконка просмотра и в ячейке без примечания (справки (расходы)).
 * type: Boolean у флагов обязателен: без emitDecoratorMetadata тип не выводится, и атрибут без значения
 * (viewable, always-viewable) пришёл бы пустой строкой "" (ложь), а не true.
 */
@Component({ name: 'c-reason-cell' })
export default class CReasonCell extends mixins(AlterationI18nMixin) {
    @Prop({
        required: false,
        default: null
    })
    private group!: IReasonGroup | null;

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    private editable!: boolean;

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    private viewable!: boolean;

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    private alwaysViewable!: boolean;

    private get displayText() {
        return reasonGroupText(this.group, this.$i18n.locale);
    }

    private get hasReason() {
        return !!this.displayText;
    }

    private get fullText() {
        return this.displayText;
    }

    private get iconHint() {
        return this.hasReason ? this.setText('reason.hint_edit') : this.setText('reason.hint_add');
    }
}
